import { render, staticRenderFns } from "./AigcQuotaGroupPage.vue?vue&type=template&id=3015d3aa&scoped=true&"
import script from "./AigcQuotaGroupPage.vue?vue&type=script&lang=js&"
export * from "./AigcQuotaGroupPage.vue?vue&type=script&lang=js&"
import style0 from "./AigcQuotaGroupPage.vue?vue&type=style&index=0&id=3015d3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015d3aa",
  null
  
)

export default component.exports